<mc-slider description="(0 is transparent, 100 is opaque)"
           field="Layer Opacity"
           max="100"
           min="0"
           mode="single"
           step="1"
           [value]="opacity"
           (valueChange)="onOpacityChange($event)">
</mc-slider>
